var spinner = $('.contacts-page__map').children('.loader');

var check_if_load = false;

var myMapTemp, myPlacemarkTemp;

function init() {
    if ($('#main-map').length) {
        var mainMap = new ymaps.Map("main-map", {
            center: [59.936884, 30.424606],
            zoom: 10,
            controls: []
        });
    }

    if ($('#map-gorohovaya').length) {
        var mapGorohovaya = new ymaps.Map("map-gorohovaya", {
            center: [59.931012, 30.317970],
            zoom: 10,
            controls: []
        });
    }

    if ($('#map-ziny-portnovoj').length) {
        var mapZinyPortnovoy = new ymaps.Map("map-ziny-portnovoj", {
            center: [59.848294, 30.256894],
            zoom: 10,
            controls: []
        });
    }

    if ($('#map-sikejrosa').length) {
        var mapSikejrosa = new ymaps.Map("map-sikejrosa", {
            center: [60.034465, 30.329406],
            zoom: 10,
            controls: []
        });
    }

    if ($('#map-dybenko').length) {
        var mapDybenko = new ymaps.Map("map-dybenko", {
            center: [59.905592, 30.479918],
            zoom: 10,
            controls: []
        });
    }

    if ($('#map-aviakonstruktorov').length) {
        var mapAviakonstruktorov = new ymaps.Map("map-aviakonstruktorov", {
            center: [60.009368, 30.244308],
            zoom: 10,
            controls: []
        });
    }

    if ($('#map-bely-kuna').length) {
        var mapBelyKuna = new ymaps.Map("map-bely-kuna", {
            center: [59.868844, 30.377546],
            zoom: 10,
            controls: []
        });
    }

    var isMobile = {
        Android: function() {
            return navigator.userAgent.match(/Android/i)
        },
        BlackBerry: function() {
            return navigator.userAgent.match(/BlackBerry/i)
        },
        iOS: function() {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i)
        },
        Opera: function() {
            return navigator.userAgent.match(/Opera Mini/i)
        },
        Windows: function() {
            return navigator.userAgent.match(/IEMobile/i)
        },
        any: function() {
            return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows())
        }
    };

    if (!(isMobile.any())) {
        if ($('#main-map').length) {
            mainMap.controls.add('zoomControl');
        }
        if ($('#map-gorohovaya').length) {
            mapGorohovaya.controls.add('zoomControl');
        }
        if ($('#map-ziny-portnovoj').length) {
            mapZinyPortnovoy.controls.add('zoomControl');
        }
        if ($('#map-sikejrosa').length) {
            mapSikejrosa.controls.add('zoomControl');
        }
        if ($('#map-dybenko').length) {
            mapDybenko.controls.add('zoomControl');
        }
        if ($('#map-aviakonstruktorov').length) {
            mapAviakonstruktorov.controls.add('zoomControl');
        }
        if ($('#map-bely-kuna').length) {
            mapBelyKuna.controls.add('zoomControl');
        }

    }

    var addressGorohovoya = new ymaps.GeoObject({
        geometry: {
            type: "Point",
            coordinates: [59.931012, 30.317970]
        },
        properties: {
            iconCaption: 'ул. Гороховая, 25'
        }
    }, {
        preset: 'islands#dotIcon',
        iconColor: '#e374bc'
    });

    var addressZinyPortnovoy = new ymaps.GeoObject({
        geometry: {
            type: "Point",
            coordinates: [59.848294, 30.256894]
        },
        properties: {
            iconCaption: 'ул. Зины Портновой, 54'
        }
    }, {
        preset: 'islands#dotIcon',
        iconColor: '#e374bc'
    });

    var addressSikejrosa = new ymaps.GeoObject({
        geometry: {
            type: "Point",
            coordinates: [60.039661, 30.326244]
        },
        properties: {
            iconCaption: 'ул. Энгельса, 115к1'
        }
    }, {
        preset: 'islands#dotIcon',
        iconColor: '#e374bc'
    });

    var addressDybenko = new ymaps.GeoObject({
        geometry: {
            type: "Point",
            coordinates: [59.905592, 30.479918]
        },
        properties: {
            iconCaption: 'ул. Дыбенко, 27к1'
        }
    }, {
        preset: 'islands#dotIcon',
        iconColor: '#e374bc'
    });

    var addressAviakonstruktorov = new ymaps.GeoObject({
        geometry: {
            type: "Point",
            coordinates: [60.009368, 30.244308]
        },
        properties: {
            iconCaption: 'пр. Авиаконструкторов, 4к1'
        }
    }, {
        preset: 'islands#dotIcon',
        iconColor: '#e374bc'
    });

    var addressBelyKuna = new ymaps.GeoObject({
        geometry: {
            type: "Point",
            coordinates: [59.868844, 30.377546]
        },
        properties: {
            iconCaption: 'ул. Белы Куна, 1к2'
        }
    }, {
        preset: 'islands#dotIcon',
        iconColor: '#e374bc'
    });

    if ($('#main-map').length) {
        mainMap.geoObjects
            .add(addressGorohovoya)
            .add(addressZinyPortnovoy)
            .add(addressSikejrosa)
            .add(addressDybenko)
            .add(addressAviakonstruktorov)
            .add(addressBelyKuna);
        mainMap.behaviors.disable(['scrollZoom']);
        mainMap.behaviors.enable(['multiTouch']);

        if (isMobile.any()) {
            mainMap.behaviors.disable(['drag'])
        }
    }
    if ($('#map-gorohovaya').length) {
        mapGorohovaya.geoObjects.add(addressGorohovoya);
        mapGorohovaya.behaviors.disable(['scrollZoom']);
        mapGorohovaya.behaviors.enable(['multiTouch']);

        if (isMobile.any()) {
            mapGorohovaya.behaviors.disable(['drag'])
        }
    }
    if ($('#map-ziny-portnovoj').length) {
        mapZinyPortnovoy.geoObjects.add(addressZinyPortnovoy);
        mapZinyPortnovoy.behaviors.disable(['scrollZoom']);
        mapZinyPortnovoy.behaviors.enable(['multiTouch']);

        if (isMobile.any()) {
            mapZinyPortnovoy.behaviors.disable(['drag'])
        }
    }
    if ($('#map-sikejrosa').length) {
        mapSikejrosa.geoObjects.add(addressSikejrosa);
        mapSikejrosa.behaviors.disable(['scrollZoom']);
        mapSikejrosa.behaviors.enable(['multiTouch']);

        if (isMobile.any()) {
            mapSikejrosa.behaviors.disable(['drag'])
        }
    }
    if ($('#map-dybenko').length) {
        mapDybenko.geoObjects.add(addressDybenko);
        mapDybenko.behaviors.disable(['scrollZoom']);
        mapDybenko.behaviors.enable(['multiTouch']);

        if (isMobile.any()) {
            mapDybenko.behaviors.disable(['drag'])
        }
    }
    if ($('#map-aviakonstruktorov').length) {
        mapAviakonstruktorov.geoObjects.add(addressAviakonstruktorov);
        mapAviakonstruktorov.behaviors.disable(['scrollZoom']);
        mapAviakonstruktorov.behaviors.enable(['multiTouch']);

        if (isMobile.any()) {
            mapAviakonstruktorov.behaviors.disable(['drag'])
        }
    }
    if ($('#map-bely-kuna').length) {
        mapBelyKuna.geoObjects.add(addressBelyKuna);
        mapBelyKuna.behaviors.disable(['scrollZoom']);
        mapBelyKuna.behaviors.enable(['multiTouch']);

        if (isMobile.any()) {
            mapBelyKuna.behaviors.disable(['drag'])
        }
    }
};


// Функция для определения полной загрузки карты (на самом деле проверяется загрузка тайлов)
function waitForTilesLoad(layer) {
    return new ymaps.vow.Promise(function(resolve, reject) {
        var tc = getTileContainer(layer),
            readyAll = true;
        tc.tiles.each(function(tile, number) {
            if (!tile.isReady()) {
                readyAll = false;
            }
        });
        if (readyAll) {
            resolve();
        } else {
            tc.events.once("ready", function() {
                resolve();
            });
        }
    });
}

function getTileContainer(layer) {
    for (var k in layer) {
        if (layer.hasOwnProperty(k)) {
            if (
                layer[k] instanceof ymaps.layer.tileContainer.CanvasContainer ||
                layer[k] instanceof ymaps.layer.tileContainer.DomContainer
            ) {
                return layer[k];
            }
        }
    }
    return null;
}

// Функция загрузки API Яндекс.Карт по требованию (в нашем случае при наведении)
function loadScript(url, callback) {
    var script = document.createElement("script");

    if (script.readyState) { // IE
        script.onreadystatechange = function() {
            if (script.readyState == "loaded" ||
                script.readyState == "complete") {
                script.onreadystatechange = null;
                callback();
            }
        };
    } else { // Другие браузеры
        script.onload = function() {
            callback();
        };
    }

    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
}

// Основная функция, которая проверяет когда мы навели на блок с классом &#34;ymap-container&#34;
var ymap = function() {
    $('.contacts-page__map').mouseenter(function() {
        if (!check_if_load) { // проверяем первый ли раз загружается Яндекс.Карта, если да, то загружаем

            // Чтобы не было повторной загрузки карты, мы изменяем значение переменной
            check_if_load = true;

            // Показываем индикатор загрузки до тех пор, пока карта не загрузится
            spinner.addClass('is-active');

            // Загружаем API Яндекс.Карт
            loadScript("https://api-maps.yandex.ru/2.1/?apikey=<b6533b85-379e-48cc-8447-b9e45ee97099>&lang=ru_RU", function() {
                // Как только API Яндекс.Карт загрузились, сразу формируем карту и помещаем в блок с идентификатором &#34;map-yandex&#34;
                ymaps.load(init);
            });
        }
    });
}

$(function() {

    //Запускаем основную функцию
    ymap();

});






// function loadScript(src) {
//     let script = document.createElement('script');
//     script.src = src;
//     script.async = true; //Можем поставить async = true
//     document.body.append(script);
// }

// function mapLoad() {
//     if (ymaps) {
//         let spbMap;
//         let moscowMap;

//         if ($('#main-map').length) {
//             var mainMap = new ymaps.Map("main-map", {
//                 center: [59.936884, 30.424606],
//                 zoom: 10,
//                 controls: []
//             });
//         }

//         if ($('#map-gorohovaya').length) {
//             var mapGorohovaya = new ymaps.Map("map-gorohovaya", {
//                 center: [59.931012, 30.317970],
//                 zoom: 10,
//                 controls: []
//             });
//         }

//         if ($('#map-ziny-portnovoj').length) {
//             var mapZinyPortnovoy = new ymaps.Map("map-ziny-portnovoj", {
//                 center: [59.848294, 30.256894],
//                 zoom: 10,
//                 controls: []
//             });
//         }

//         if ($('#map-sikejrosa').length) {
//             var mapSikejrosa = new ymaps.Map("map-sikejrosa", {
//                 center: [60.034465, 30.329406],
//                 zoom: 10,
//                 controls: []
//             });
//         }

//         if ($('#map-dybenko').length) {
//             var mapDybenko = new ymaps.Map("map-dybenko", {
//                 center: [59.905592, 30.479918],
//                 zoom: 10,
//                 controls: []
//             });
//         }

//         if ($('#map-aviakonstruktorov').length) {
//             var mapAviakonstruktorov = new ymaps.Map("map-aviakonstruktorov", {
//                 center: [60.009368, 30.244308],
//                 zoom: 10,
//                 controls: []
//             });
//         }

//         var isMobile = {
//             Android: function() {
//                 return navigator.userAgent.match(/Android/i)
//             },
//             BlackBerry: function() {
//                 return navigator.userAgent.match(/BlackBerry/i)
//             },
//             iOS: function() {
//                 return navigator.userAgent.match(/iPhone|iPad|iPod/i)
//             },
//             Opera: function() {
//                 return navigator.userAgent.match(/Opera Mini/i)
//             },
//             Windows: function() {
//                 return navigator.userAgent.match(/IEMobile/i)
//             },
//             any: function() {
//                 return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows())
//             }
//         };

//         if (!(isMobile.any())) {
//             if ($('#main-map').length) {
//                 mainMap.controls.add('zoomControl');
//             }
//             if ($('#map-gorohovaya').length) {
//                 mapGorohovaya.controls.add('zoomControl');
//             }
//             if ($('#map-ziny-portnovoj').length) {
//                 mapZinyPortnovoy.controls.add('zoomControl');
//             }
//             if ($('#map-sikejrosa').length) {
//                 mapSikejrosa.controls.add('zoomControl');
//             }
//             if ($('#map-dybenko').length) {
//                 mapDybenko.controls.add('zoomControl');
//             }
//             if ($('#map-aviakonstruktorov').length) {
//                 mapAviakonstruktorov.controls.add('zoomControl');
//             }
//         }

//         var addressGorohovoya = new ymaps.GeoObject({
//             geometry: {
//                 type: "Point",
//                 coordinates: [59.931012, 30.317970]
//             },
//             properties: {
//                 iconCaption: 'ул. Гороховая, 25'
//             }
//         }, {
//             preset: 'islands#dotIcon',
//             iconColor: '#e374bc'
//         });

//         var addressZinyPortnovoy = new ymaps.GeoObject({
//             geometry: {
//                 type: "Point",
//                 coordinates: [59.848294, 30.256894]
//             },
//             properties: {
//                 iconCaption: 'ул. Зины Портновой, 54'
//             }
//         }, {
//             preset: 'islands#dotIcon',
//             iconColor: '#e374bc'
//         });

//         var addressSikejrosa = new ymaps.GeoObject({
//             geometry: {
//                 type: "Point",
//                 coordinates: [60.034465, 30.329406]
//             },
//             properties: {
//                 iconCaption: 'ул. Сикейроса, 11к1'
//             }
//         }, {
//             preset: 'islands#dotIcon',
//             iconColor: '#e374bc'
//         });

//         var addressDybenko = new ymaps.GeoObject({
//             geometry: {
//                 type: "Point",
//                 coordinates: [59.905592, 30.479918]
//             },
//             properties: {
//                 iconCaption: 'ул. Дыбенко, 27к1'
//             }
//         }, {
//             preset: 'islands#dotIcon',
//             iconColor: '#e374bc'
//         });

//         var addressAviakonstruktorov = new ymaps.GeoObject({
//             geometry: {
//                 type: "Point",
//                 coordinates: [60.009368, 30.244308]
//             },
//             properties: {
//                 iconCaption: 'пр. Авиаконструкторов, 4к1'
//             }
//         }, {
//             preset: 'islands#dotIcon',
//             iconColor: '#e374bc'
//         });

//         if ($('#main-map').length) {
//             mainMap.geoObjects
//                 .add(addressGorohovoya)
//                 .add(addressZinyPortnovoy)
//                 .add(addressSikejrosa)
//                 .add(addressDybenko)
//                 .add(addressAviakonstruktorov);
//             mainMap.behaviors.disable(['scrollZoom']);
//             mainMap.behaviors.enable(['multiTouch']);

//             if (isMobile.any()) {
//                 mainMap.behaviors.disable(['drag'])
//             }
//         }
//         if ($('#map-gorohovaya').length) {
//             mapGorohovaya.geoObjects.add(addressGorohovoya);
//             mapGorohovaya.behaviors.disable(['scrollZoom']);
//             mapGorohovaya.behaviors.enable(['multiTouch']);

//             if (isMobile.any()) {
//                 mapGorohovaya.behaviors.disable(['drag'])
//             }
//         }
//         if ($('#map-ziny-portnovoj').length) {
//             mapZinyPortnovoy.geoObjects.add(addressZinyPortnovoy);
//             mapZinyPortnovoy.behaviors.disable(['scrollZoom']);
//             mapZinyPortnovoy.behaviors.enable(['multiTouch']);

//             if (isMobile.any()) {
//                 mapZinyPortnovoy.behaviors.disable(['drag'])
//             }
//         }
//         if ($('#map-sikejrosa').length) {
//             mapSikejrosa.geoObjects.add(addressSikejrosa);
//             mapSikejrosa.behaviors.disable(['scrollZoom']);
//             mapSikejrosa.behaviors.enable(['multiTouch']);

//             if (isMobile.any()) {
//                 mapSikejrosa.behaviors.disable(['drag'])
//             }
//         }
//         if ($('#map-dybenko').length) {
//             mapDybenko.geoObjects.add(addressDybenko);
//             mapDybenko.behaviors.disable(['scrollZoom']);
//             mapDybenko.behaviors.enable(['multiTouch']);

//             if (isMobile.any()) {
//                 mapDybenko.behaviors.disable(['drag'])
//             }
//         }
//         if ($('#map-aviakonstruktorov').length) {
//             mapAviakonstruktorov.geoObjects.add(addressAviakonstruktorov);
//             mapAviakonstruktorov.behaviors.disable(['scrollZoom']);
//             mapAviakonstruktorov.behaviors.enable(['multiTouch']);

//             if (isMobile.any()) {
//                 mapAviakonstruktorov.behaviors.disable(['drag'])
//             }
//         }
//     };
// }

// document.addEventListener("DOMContentLoaded", () => {
//     loadScript('https://api-maps.yandex.ru/2.1/?apikey=<b6533b85-379e-48cc-8447-b9e45ee97099>&lang=ru_RU');
//     setTimeout(mapLoad, 5000);
// });



// OLD


//     if ($('#main-map').length) {
//         var mainMap = new ymaps.Map("main-map", {
//             center: [59.936884, 30.424606],
//             zoom: 10,
//             controls: []
//         });
//     }

//     if ($('#map-gorohovaya').length) {
//         var mapGorohovaya = new ymaps.Map("map-gorohovaya", {
//             center: [59.931012, 30.317970],
//             zoom: 10,
//             controls: []
//         });
//     }

//     if ($('#map-ziny-portnovoj').length) {
//         var mapZinyPortnovoy = new ymaps.Map("map-ziny-portnovoj", {
//             center: [59.848294, 30.256894],
//             zoom: 10,
//             controls: []
//         });
//     }

//     if ($('#map-sikejrosa').length) {
//         var mapSikejrosa = new ymaps.Map("map-sikejrosa", {
//             center: [60.034465, 30.329406],
//             zoom: 10,
//             controls: []
//         });
//     }

//     if ($('#map-dybenko').length) {
//         var mapDybenko = new ymaps.Map("map-dybenko", {
//             center: [59.905592, 30.479918],
//             zoom: 10,
//             controls: []
//         });
//     }

//     if ($('#map-aviakonstruktorov').length) {
//         var mapAviakonstruktorov = new ymaps.Map("map-aviakonstruktorov", {
//             center: [60.009368, 30.244308],
//             zoom: 10,
//             controls: []
//         });
//     }

//     var isMobile = {
//         Android: function() {
//             return navigator.userAgent.match(/Android/i)
//         },
//         BlackBerry: function() {
//             return navigator.userAgent.match(/BlackBerry/i)
//         },
//         iOS: function() {
//             return navigator.userAgent.match(/iPhone|iPad|iPod/i)
//         },
//         Opera: function() {
//             return navigator.userAgent.match(/Opera Mini/i)
//         },
//         Windows: function() {
//             return navigator.userAgent.match(/IEMobile/i)
//         },
//         any: function() {
//             return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows())
//         }
//     };

//     if (!(isMobile.any())) {
//         if ($('#main-map').length) {
//             mainMap.controls.add('zoomControl');
//         }
//         if ($('#map-gorohovaya').length) {
//             mapGorohovaya.controls.add('zoomControl');
//         }
//         if ($('#map-ziny-portnovoj').length) {
//             mapZinyPortnovoy.controls.add('zoomControl');
//         }
//         if ($('#map-sikejrosa').length) {
//             mapSikejrosa.controls.add('zoomControl');
//         }
//         if ($('#map-dybenko').length) {
//             mapDybenko.controls.add('zoomControl');
//         }
//         if ($('#map-aviakonstruktorov').length) {
//             mapAviakonstruktorov.controls.add('zoomControl');
//         }
//     }

//     var addressGorohovoya = new ymaps.GeoObject({
//         geometry: {
//             type: "Point",
//             coordinates: [59.931012, 30.317970]
//         },
//         properties: {
//             iconCaption: 'ул. Гороховая, 25'
//         }
//     }, {
//         preset: 'islands#dotIcon',
//         iconColor: '#e374bc'
//     });

//     var addressZinyPortnovoy = new ymaps.GeoObject({
//         geometry: {
//             type: "Point",
//             coordinates: [59.848294, 30.256894]
//         },
//         properties: {
//             iconCaption: 'ул. Зины Портновой, 54'
//         }
//     }, {
//         preset: 'islands#dotIcon',
//         iconColor: '#e374bc'
//     });

//     var addressSikejrosa = new ymaps.GeoObject({
//         geometry: {
//             type: "Point",
//             coordinates: [60.034465, 30.329406]
//         },
//         properties: {
//             iconCaption: 'ул. Сикейроса, 11к1'
//         }
//     }, {
//         preset: 'islands#dotIcon',
//         iconColor: '#e374bc'
//     });

//     var addressDybenko = new ymaps.GeoObject({
//         geometry: {
//             type: "Point",
//             coordinates: [59.905592, 30.479918]
//         },
//         properties: {
//             iconCaption: 'ул. Дыбенко, 27к1'
//         }
//     }, {
//         preset: 'islands#dotIcon',
//         iconColor: '#e374bc'
//     });

//     var addressAviakonstruktorov = new ymaps.GeoObject({
//         geometry: {
//             type: "Point",
//             coordinates: [60.009368, 30.244308]
//         },
//         properties: {
//             iconCaption: 'пр. Авиаконструкторов, 4к1'
//         }
//     }, {
//         preset: 'islands#dotIcon',
//         iconColor: '#e374bc'
//     });

//     if ($('#main-map').length) {
//         mainMap.geoObjects
//             .add(addressGorohovoya)
//             .add(addressZinyPortnovoy)
//             .add(addressSikejrosa)
//             .add(addressDybenko)
//             .add(addressAviakonstruktorov);
//         mainMap.behaviors.disable(['scrollZoom']);
//         mainMap.behaviors.enable(['multiTouch']);

//         if (isMobile.any()) {
//             mainMap.behaviors.disable(['drag'])
//         }
//     }
//     if ($('#map-gorohovaya').length) {
//         mapGorohovaya.geoObjects.add(addressGorohovoya);
//         mapGorohovaya.behaviors.disable(['scrollZoom']);
//         mapGorohovaya.behaviors.enable(['multiTouch']);

//         if (isMobile.any()) {
//             mapGorohovaya.behaviors.disable(['drag'])
//         }
//     }
//     if ($('#map-ziny-portnovoj').length) {
//         mapZinyPortnovoy.geoObjects.add(addressZinyPortnovoy);
//         mapZinyPortnovoy.behaviors.disable(['scrollZoom']);
//         mapZinyPortnovoy.behaviors.enable(['multiTouch']);

//         if (isMobile.any()) {
//             mapZinyPortnovoy.behaviors.disable(['drag'])
//         }
//     }
//     if ($('#map-sikejrosa').length) {
//         mapSikejrosa.geoObjects.add(addressSikejrosa);
//         mapSikejrosa.behaviors.disable(['scrollZoom']);
//         mapSikejrosa.behaviors.enable(['multiTouch']);

//         if (isMobile.any()) {
//             mapSikejrosa.behaviors.disable(['drag'])
//         }
//     }
//     if ($('#map-dybenko').length) {
//         mapDybenko.geoObjects.add(addressDybenko);
//         mapDybenko.behaviors.disable(['scrollZoom']);
//         mapDybenko.behaviors.enable(['multiTouch']);

//         if (isMobile.any()) {
//             mapDybenko.behaviors.disable(['drag'])
//         }
//     }
//     if ($('#map-aviakonstruktorov').length) {
//         mapAviakonstruktorov.geoObjects.add(addressAviakonstruktorov);
//         mapAviakonstruktorov.behaviors.disable(['scrollZoom']);
//         mapAviakonstruktorov.behaviors.enable(['multiTouch']);

//         if (isMobile.any()) {
//             mapAviakonstruktorov.behaviors.disable(['drag'])
//         }
//     }
// };
